// Console v4 look (backlog row 234, Storm 2026-10-31): a hidden switch so the
// redesign can be proved on a real call before it becomes the default.
//
//   agents.knktr.ai/?ui=v4          turn the v4 look on (remembered per browser)
//   agents.knktr.ai/?ui=v3          turn it off again
//   agents.knktr.ai/?theme=light    v4 light theme (?theme=dark to go back)
//
// The choice lives in localStorage so it survives the Cognito and Connect
// sign-in redirects, which drop the query string. Storage can be blocked
// (private window, managed browser): every read and write is wrapped, and the
// fallback is the current v3 look.

const UI_KEY = 'knktr.console.ui';
const THEME_KEY = 'knktr.console.theme';

function read(key) {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
function write(key, value) {
  try {
    if (value == null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch { /* storage blocked: the URL value still applies to this page load */ }
}

export function readUiFlags(search = (typeof window !== 'undefined' ? window.location.search : '')) {
  const params = new URLSearchParams(search);
  let ui = params.get('ui');
  if (ui === 'v4') write(UI_KEY, 'v4');
  else if (ui === 'v3') write(UI_KEY, null);
  else ui = read(UI_KEY);

  let theme = params.get('theme');
  if (theme === 'light' || theme === 'dark') write(THEME_KEY, theme === 'light' ? 'light' : null);
  else theme = read(THEME_KEY);

  const v4 = ui === 'v4';
  return { v4, light: v4 && theme === 'light' };
}

// Read once per page load: the flag never changes mid-session.
let cached = null;
export function uiFlags() {
  if (!cached) cached = readUiFlags();
  return cached;
}
export function isV4() { return uiFlags().v4; }
